import { render, staticRenderFns } from "./TcoProductsModalConfirm.vue?vue&type=template&id=365199fe"
import script from "./TcoProductsModalConfirm.vue?vue&type=script&lang=js"
export * from "./TcoProductsModalConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports